/**
 * Product Stories v5
 * - Setas posicionadas estrategicamente
 * - Cores configuráveis via data-attributes
 * - ATC abre carrinho automaticamente
 * - Tamanhos indisponíveis com risco
 * - Descrição estilo Reise
 */
(function () {
  'use strict';
  console.log('[PV] v5');

  var modal=null, stories=[], idx=0, muted=true;
  var variants=[], selectedId=null, pData={}, colors={};

  function isDesk(){ return window.innerWidth>=900; }
  function iframeSrc(t,id){
    if(t==='youtube') return 'https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&mute=1&rel=0&playsinline=1&controls=1';
    if(t==='vimeo')   return 'https://player.vimeo.com/video/'+id+'?autoplay=1&muted=1&title=0&byline=0&portrait=0';
    return '';
  }
  function Q(id){ return document.getElementById(id); }

  /* ── Build modal ───────────────────── */
  function build(){
    if(modal) return;
    modal=document.createElement('div');
    modal.id='pv-root';
    modal.innerHTML=
      '<div id="pv-bg"></div>'+
      '<div id="pv-cnt">'+
        '<button id="pv-close" type="button">&times;</button>'+
        '<button id="pv-prev" type="button">&#8249;</button>'+
        '<div id="pv-vwrap">'+
          '<div id="pv-prog"></div>'+
        '</div>'+
        '<button id="pv-next" type="button">&#8250;</button>'+
        '<div id="pv-panel">'+
          '<div id="pv-imgs"></div>'+
          '<h3 id="pv-title"></h3>'+
          '<div id="pv-price"></div>'+
          '<div id="pv-sizes-wrap">'+
            '<p id="pv-size-lbl">Tamanho</p>'+
            '<div id="pv-sizes"></div>'+
          '</div>'+
          '<button id="pv-atc" type="button" disabled>Adicionar ao carrinho</button>'+
          '<p id="pv-msg"></p>'+
          '<details id="pv-desc-box">'+
            '<summary>Descri&ccedil;&atilde;o <span id="pv-desc-chevron">&#8964;</span></summary>'+
            '<div id="pv-desc-content"></div>'+
          '</details>'+
          '<div id="pv-dots"></div>'+
        '</div>'+
      '</div>';
    document.body.appendChild(modal);

    Q('pv-bg').onclick    = close;
    Q('pv-close').onclick = close;
    Q('pv-prev').onclick  = function(){ go(idx-1); };
    Q('pv-next').onclick  = function(){ go(idx+1); };

    document.addEventListener('keydown',function(e){
      if(!modal.classList.contains('pv-open')) return;
      if(e.key==='Escape') close();
      if(e.key==='ArrowLeft') go(idx-1);
      if(e.key==='ArrowRight') go(idx+1);
    });
    window.addEventListener('resize',function(){ if(modal.classList.contains('pv-open')) applyLayout(); });

    var tx=0;
    Q('pv-vwrap').addEventListener('touchstart',function(e){tx=e.changedTouches[0].clientX;},{passive:true});
    Q('pv-vwrap').addEventListener('touchend',function(e){
      var dx=tx-e.changedTouches[0].clientX; if(Math.abs(dx)>50) go(dx>0?idx+1:idx-1);
    },{passive:true});
  }

  /* ── Layout ─────────────────────────── */
  function applyLayout(){
    var desk=isDesk();
    var bg=Q('pv-bg'), cnt=Q('pv-cnt'), vw=Q('pv-vwrap');
    var panel=Q('pv-panel'), prev=Q('pv-prev'), next=Q('pv-next');
    var closeB=Q('pv-close'), dots=Q('pv-dots');

    var aBg    = colors.arrowBg    || '#333333';
    var aClr   = colors.arrowColor || '#ffffff';
    var arrowBase = 'width:40px;height:40px;border:none;border-radius:4px;font-size:26px;font-weight:300;'+
      'cursor:pointer;display:flex;align-items:center;justify-content:center;'+
      'background:'+aBg+';color:'+aClr+';z-index:100003;';

    /* Overlay */
    bg.style.cssText='position:fixed;inset:0;z-index:100000;background:rgba(0,0,0,.9);';

    if(desk){
      var h=Math.round(window.innerHeight*0.88);
      var w=Math.round(h*9/16);
      var panelW=360;
      var totalW=w+panelW;

      /* Container: centrado via transform */
      cnt.style.cssText=
        'position:fixed;top:50%;left:50%;'+
        'transform:translate(-50%,-50%);'+
        'z-index:100001;display:flex;flex-direction:row;'+
        'align-items:stretch;overflow:visible;';

      /* Vídeo */
      vw.style.cssText=
        'position:relative;width:'+w+'px;height:'+h+'px;'+
        'background:#000;overflow:hidden;flex:0 0 auto;';

      /* Painel */
      panel.style.cssText=
        'width:'+panelW+'px;height:'+h+'px;overflow-y:auto;'+
        'background:#fff;display:flex;flex-direction:column;gap:12px;'+
        'padding:20px 20px 32px;flex:0 0 '+panelW+'px;';

      /* Seta esquerda: fora do container à esquerda */
      prev.style.cssText=
        'position:fixed;'+
        'left:calc(50% - '+(totalW/2+56)+'px);'+
        'top:50%;transform:translateY(-50%);'+arrowBase;

      /* Seta direita: entre vídeo e painel */
      next.style.cssText=
        'position:absolute;'+
        'left:'+(w+12)+'px;'+
        'top:50%;transform:translateY(-50%);'+arrowBase;

      /* Fechar: topo direito do painel */
      closeB.style.cssText=
        'position:absolute;top:-44px;right:0;'+
        'width:36px;height:36px;background:#111;border:none;'+
        'color:#fff;font-size:20px;border-radius:4px;cursor:pointer;'+
        'display:flex;align-items:center;justify-content:center;z-index:100004;';

      if(dots) dots.style.display='none';
    } else {
      /* Mobile */
      cnt.style.cssText=
        'position:fixed;inset:0;z-index:100001;'+
        'display:flex;flex-direction:column;'+
        'overflow-y:auto;scrollbar-width:none;';

      vw.style.cssText=
        'position:relative;flex:0 0 100dvh;width:100%;background:#000;overflow:hidden;';

      panel.style.cssText=
        'flex:1 0 auto;background:#fff;'+
        'display:flex;flex-direction:column;gap:12px;'+
        'padding:20px 16px 40px;';

      prev.style.cssText=
        'position:absolute;left:10px;top:50%;transform:translateY(-50%);'+arrowBase;
      next.style.cssText=
        'position:absolute;right:10px;top:50%;transform:translateY(-50%);'+arrowBase;

      closeB.style.cssText=
        'position:fixed;top:12px;right:12px;'+
        'width:36px;height:36px;background:#111;border:none;'+
        'color:#fff;font-size:20px;border-radius:4px;cursor:pointer;'+
        'display:flex;align-items:center;justify-content:center;z-index:100004;';

      if(dots) dots.style.display='flex';
    }

    /* ATC: aplica classes nativas do tema + estilo de largura */
    var atcBtn=Q('pv-atc');
    if(atcBtn){
      if(colors.atcClass){
        atcBtn.className = colors.atcClass;
        atcBtn.style.cssText = 'width:100%;margin-top:4px;';
      } else {
        atcBtn.style.cssText =
          'width:100%;height:50px;background:'+(colors.atcBg||'#111')+';color:'+(colors.atcColor||'#fff')+';'+
          'border:none;border-radius:6px;font-size:.9em;font-weight:600;'+
          'letter-spacing:.05em;cursor:pointer;text-transform:uppercase;';
      }
    }

    updateArrows();
  }

  /* ── Open / Close ──────────────────── */
  function open(block, list, n){
    build();
    pData={
      title:   block.getAttribute('data-pv-product-title')  ||'',
      img:     block.getAttribute('data-pv-product-img')    ||'',
      price:   block.getAttribute('data-pv-product-price')  ||'',
      compare: block.getAttribute('data-pv-product-compare')||'',
      desc:    block.getAttribute('data-pv-product-desc')   ||''
    };
    colors={
      arrowBg:    block.getAttribute('data-pv-arrow-bg')   ||'#333333',
      arrowColor: block.getAttribute('data-pv-arrow-color')||'#ffffff',
      atcBg:      block.getAttribute('data-pv-atc-bg')     ||'#111111',
      atcColor:   block.getAttribute('data-pv-atc-color')  ||'#ffffff',
      atcClass:   block.getAttribute('data-pv-atc-class')  ||''
    };
    try{ variants=JSON.parse(block.getAttribute('data-pv-variants')||'[]'); }catch(e){ variants=[]; }
    stories=list; idx=n; muted=true; selectedId=null;

    modal.classList.add('pv-open');
    modal.style.cssText='';
    document.body.style.overflow='hidden';
    applyLayout();
    fillPanel();
    buildDots(); buildBars();
    loadVid();
    var c=Q('pv-cnt'); if(c) c.scrollTop=0;
  }

  function close(){
    if(!modal) return;
    modal.classList.remove('pv-open');
    /* Remove completamente o modal do fluxo visual e de eventos */
    modal.style.cssText='display:none;pointer-events:none;';
    var bg=Q('pv-bg'), cnt=Q('pv-cnt');
    if(bg)  bg.style.cssText='display:none;pointer-events:none;';
    if(cnt) cnt.style.cssText='display:none;pointer-events:none;';
    document.body.style.overflow='';
    clearVid();
  }

  function go(n){
    if(n<0||n>=stories.length) return;
    if(stories[idx]) stories[idx].classList.add('pv-seen');
    idx=n;
    var c=Q('pv-cnt'); if(c) c.scrollTop=0;
    loadVid(); updateBars(); updateArrows();
  }

  /* ── Vídeo ─────────────────────────── */
  function clearVid(){
    var w=Q('pv-vwrap'); if(!w) return;
    var el=w.querySelector('video,iframe'); if(!el) return;
    if(el.tagName==='VIDEO'){el.pause();el.src='';}
    el.remove();
  }

  function loadVid(){
    clearVid();
    var s=stories[idx]; if(!s) return;
    var w=Q('pv-vwrap'), type=s.getAttribute('data-pv-type');

    if(type==='native'){
      var url=s.getAttribute('data-pv-url');
      if(!url){ if(mb) mb.style.display='none'; return; }
      var v=document.createElement('video');
      v.muted=false; v.autoplay=true;
      v.setAttribute('playsinline','');
      /* Sem controls nativos — visual limpo como Stories */
      v.preload='auto';
      v.style.cssText='position:absolute;inset:0;width:100%;height:100%;background:#000;object-fit:cover;';
      v.src=url; w.appendChild(v);
      v.play().catch(function(){
        /* Browser bloqueou som — toca mudo e mostra botão de ativar som */
        v.muted=true;
        v.play().catch(function(){ showPlay(w,v); });
        showSoundBtn(w,v);
      });
      v.addEventListener('ended',function(){ if(idx<stories.length-1) go(idx+1); else close(); });

    } else {
      var id=s.getAttribute('data-pv-id'), src=iframeSrc(type,id);
      if(!src){ if(mb) mb.style.display='none'; return; }
      var f=document.createElement('iframe');
      f.src=src; f.allow='autoplay;fullscreen;picture-in-picture';
      f.allowFullscreen=true; f.setAttribute('frameborder','0');
      f.style.cssText='position:absolute;inset:0;width:100%;height:100%;border:none;';
      w.appendChild(f);
    }
  }



  function showPlay(w,v){
    var b=document.createElement('button'); b.type='button'; b.innerHTML='&#9654;';
    b.style.cssText='position:absolute;inset:0;width:100%;height:100%;background:rgba(0,0,0,.35);border:none;color:#fff;font-size:56px;cursor:pointer;z-index:4;display:flex;align-items:center;justify-content:center;';
    w.appendChild(b); b.onclick=function(){b.remove();v.play().catch(function(){});};
  }

  function showSoundBtn(w,v){
    var b=document.createElement('button'); b.type='button';
    b.innerHTML='<svg width="14" height="14" viewBox="0 0 24 24" fill="#fff"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>';
    b.title='Ativar som';
    b.style.cssText='position:absolute;bottom:12px;right:12px;'+
      'width:34px;height:34px;border-radius:50%;'+
      'background:rgba(0,0,0,.6);border:1.5px solid rgba(255,255,255,.5);'+
      'color:#fff;cursor:pointer;z-index:8;'+
      'display:flex;align-items:center;justify-content:center;';
    w.appendChild(b);
    b.onclick=function(e){
      e.stopPropagation();
      v.muted=false;
      v.play().catch(function(){});
      b.remove();
    };
  }

  /* ── Painel produto ─────────────────── */
  function fillPanel(){
    /* Imagens */
    var imgs=Q('pv-imgs'); imgs.innerHTML='';
    if(pData.img){
      var im=document.createElement('img');
      im.src=pData.img; im.alt=pData.title;
      im.style.cssText='width:80px;height:80px;border-radius:8px;object-fit:cover;border:1px solid #eee;';
      imgs.appendChild(im);
    }

    /* Título */
    Q('pv-title').textContent=pData.title;
    Q('pv-title').style.cssText='font-size:1.05em;font-weight:700;color:#111;margin:0;line-height:1.3;';

    /* Preço */
    var pr=Q('pv-price'); pr.innerHTML='';
    pr.style.cssText='display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin:0;';
    if(pData.compare&&pData.compare!==pData.price){
      var s=document.createElement('span');
      s.style.cssText='font-size:.9em;color:#999;text-decoration:line-through;';
      s.textContent=pData.compare; pr.appendChild(s);
    }
    var cur=document.createElement('span');
    cur.style.cssText='font-size:1.1em;font-weight:700;color:#111;';
    cur.textContent=pData.price; pr.appendChild(cur);

    /* Tamanhos */
    var sz=Q('pv-sizes'); sz.innerHTML=''; selectedId=null;
    var at=Q('pv-atc'); at.disabled=true; at.textContent='Selecione um tamanho';
    var mg=Q('pv-msg'); mg.textContent=''; mg.style.cssText='font-size:.75em;min-height:14px;margin:0;';
    var lb=Q('pv-size-lbl');
    lb.style.cssText='font-size:.75em;color:#555;margin:0;text-transform:uppercase;letter-spacing:.06em;font-weight:600;';

    if(!variants.length){
      Q('pv-sizes-wrap').style.display='none';
      at.disabled=false; at.textContent='Adicionar ao carrinho'; return;
    }
    Q('pv-sizes-wrap').style.display='';
    sz.style.cssText='display:flex;flex-wrap:wrap;gap:6px;';

    variants.forEach(function(v){
      var b=document.createElement('button'); b.type='button';
      var avail=v.available;
      b.textContent=String(v.title||'').split(' / ').pop();
      b.disabled=!avail;

      var baseStyle='min-width:44px;height:40px;padding:0 12px;border-radius:6px;font-size:.85em;cursor:'+(avail?'pointer':'not-allowed')+';transition:all .15s;';
      if(!avail){
        /* Indisponível: borda tracejada, texto riscado, cinza */
        b.style.cssText=baseStyle+'border:1.5px dashed #ccc;background:#f5f5f5;color:#bbb;text-decoration:line-through;position:relative;';
      } else {
        b.style.cssText=baseStyle+'border:1.5px solid #ddd;background:#fff;color:#111;';
      }

      if(avail){
        b.onclick=function(){
          sz.querySelectorAll('button').forEach(function(x){
            if(x.dataset.avail==='1'){
              x.style.background='#fff'; x.style.color='#111'; x.style.borderColor='#ddd';
              x.style.borderStyle='solid';
            }
          });
          b.style.background=colors.atcBg||'#111'; b.style.color=colors.atcColor||'#fff'; b.style.borderColor=colors.atcBg||'#111';
          selectedId=v.id; at.disabled=false; at.textContent='Adicionar ao carrinho'; mg.textContent='';
        };
        b.dataset.avail='1';
      }
      sz.appendChild(b);
    });

    /* Descrição estilo Reise */
    var descBox=Q('pv-desc-box');
    descBox.style.cssText='border-top:1px solid #f0f0f0;padding-top:12px;margin-top:4px;';
    var descContent=Q('pv-desc-content');
    descContent.innerHTML=pData.desc||'';
    /* CSS compacto para descrição — evita h1/h2 gigantes */
    if(!document.getElementById('pv-desc-style')){
      var st=document.createElement('style'); st.id='pv-desc-style';
      st.textContent=
        '#pv-desc-content{font-size:.78em;color:#555;line-height:1.6;max-height:140px;overflow-y:auto;}'+
        '#pv-desc-content h1,#pv-desc-content h2,#pv-desc-content h3,'+
        '#pv-desc-content h4,#pv-desc-content h5{font-size:1em;font-weight:600;margin:.3em 0 .2em;}'+
        '#pv-desc-content p{margin:.2em 0;}'+
        '#pv-desc-content ul,#pv-desc-content ol{padding-left:1.4em;margin:.2em 0;}'+
        '#pv-desc-content li{margin:.1em 0;}'+
        '#pv-desc-content strong{font-weight:600;}'+
        '#pv-desc-content img{max-width:100%;height:auto;}';
      document.head.appendChild(st);
    }
    descContent.style.cssText='font-size:.82em;color:#444;line-height:1.7;margin-top:10px;';
    var summary=descBox.querySelector('summary');
    if(summary){
      summary.style.cssText='font-size:.95em;font-weight:700;cursor:pointer;list-style:none;'+
        'display:flex;justify-content:space-between;align-items:center;color:#111;padding:4px 0;'+
        'user-select:none;';
      summary.addEventListener('click',function(){
        var ch=Q('pv-desc-chevron');
        if(ch) ch.style.transform=descBox.open?'rotate(0deg)':'rotate(180deg)';
      });
    }
    var ch=Q('pv-desc-chevron');
    if(ch) ch.style.cssText='font-size:.8em;opacity:.5;transition:transform .2s;display:inline-block;';

    /* Dots */
    var dots=Q('pv-dots');
    if(dots) dots.style.cssText='display:flex;justify-content:center;gap:5px;padding:8px 0 0;';
  }

  /* ── ATC ───────────────────────────── */
  function setupAtc(){
    var at=Q('pv-atc'); if(!at) return;
    at.onclick=function(){
      var mg=Q('pv-msg');
      if(variants.length&&!selectedId){ mg.textContent='Selecione um tamanho.'; mg.style.color='#d00'; return; }
      var vid=selectedId||(variants[0]&&variants[0].id); if(!vid) return;
      at.disabled=true; at.textContent='Adicionando…';

      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:vid,quantity:1})
      })
      .then(function(r){ return r.json(); })
      .then(function(d){
        if(d.id){
          /* Fecha o modal imediatamente */
          close();
          /* Abre o carrinho — window.cart.getCart() é a API interna do Impulse */
          if(window.cart && typeof window.cart.getCart === 'function'){
            window.cart.getCart();
          } else {
            var cartBtn = document.querySelector('[data-cart-drawer-toggle]');
            if(!cartBtn) cartBtn = document.querySelector('[data-cart-toggle]');
            if(cartBtn) cartBtn.click();
          }
        } else { throw new Error(d.description||'Erro'); }
      })
      .catch(function(e){
        at.disabled=false; at.textContent='Adicionar ao carrinho';
        if(mg){ mg.textContent=e.message||'Erro.'; mg.style.color='#d00'; }
      });
    };
  }

  /* ── Dots / Bars / Arrows ──────────── */
  function buildDots(){
    var el=Q('pv-dots'); if(!el) return; el.innerHTML='';
    if(stories.length<=1) return;
    stories.forEach(function(_,i){
      var d=document.createElement('span');
      d.dataset.di=i;
      d.style.cssText='width:5px;height:5px;border-radius:50%;background:'+(i===idx?'#111':'#ccc')+';transition:all .15s;display:inline-block;';
      el.appendChild(d);
    });
  }
  function updateDots(){
    var el=Q('pv-dots'); if(!el) return;
    el.querySelectorAll('span').forEach(function(d,i){
      d.style.background=i===idx?'#111':'#ccc';
      d.style.transform=i===idx?'scale(1.4)':'scale(1)';
    });
  }
  function buildBars(){
    var p=Q('pv-prog'); if(!p) return; p.innerHTML='';
    p.style.cssText='position:absolute;top:10px;left:10px;right:10px;display:flex;gap:3px;z-index:6;pointer-events:none;';
    stories.forEach(function(_,i){
      var b=document.createElement('div');
      b.style.cssText='flex:1;height:2px;border-radius:2px;background:'+(i<=idx?'rgba(255,255,255,.95)':'rgba(255,255,255,.3)')+';';
      p.appendChild(b);
    });
  }
  function updateBars(){
    var bs=Q('pv-prog'); if(!bs) return;
    bs.querySelectorAll('div').forEach(function(b,i){
      b.style.background=i<=idx?'rgba(255,255,255,.95)':'rgba(255,255,255,.3)';
    });
  }
  function updateArrows(){
    var pr=Q('pv-prev'),nx=Q('pv-next');
    if(pr) pr.disabled=idx===0;
    if(nx) nx.disabled=idx===stories.length-1;
    if(pr) pr.style.opacity=idx===0?'0.25':'1';
    if(nx) nx.style.opacity=idx===stories.length-1?'0.25':'1';
    updateDots();
  }

  /* ── Delegação capture ─────────────── */
  document.addEventListener('click',function(e){
    /* Garante que não interfere com outros elementos do tema */
    if(!e.target.closest('[data-pv-stories-block]')) return;
    var btn=e.target.closest('[data-pv-story]'); if(!btn) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var block=btn.closest('[data-pv-stories-block]'); if(!block) return;
    var all=Array.from(block.querySelectorAll('[data-pv-story]'));
    open(block,all,parseInt(btn.getAttribute('data-pv-index'),10)||0);
    setTimeout(setupAtc, 50);
  },true);

})();